import {
  Stepper,
  Step,
  StepLabel,
  StepIconProps,
  styled,
  StepConnector,
  stepConnectorClasses,
} from "@mui/material";
import React from "react";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.primary.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.primary.main,
    },
  },
  [`$ .${!stepConnectorClasses.active && !stepConnectorClasses.completed}`]: {
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
  },
}));
const ColorlibStepIconRoot = styled("div")<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  ...(!ownerState.completed &&
    !ownerState.active && {
      backgroundColor:
        theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
    }),
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundColor: theme.palette.primary.main,
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundColor: theme.palette.primary.main,
  }),
}));

export default function RopFormsStepper(props: {
  activeStep: number;
  steps: {
    label: string;
    icon: React.ReactNode;
  }[];
}) {
  const { steps } = props;

  const icons = props.steps.map((step) => step.icon);
  const selectedStep = steps[props.activeStep];
  return (
    <>
      <Stepper
        sx={{
          display: { xs: "flex", sm: "none" },
        }}
        alternativeLabel
        activeStep={props.activeStep}
        connector={<ColorlibConnector />}
      >
        <Step key={selectedStep.label}>
          <StepLabel StepIconComponent={ColorlibStepIcon}>
            {selectedStep.label}
          </StepLabel>
        </Step>
      </Stepper>

      <Stepper
        alternativeLabel
        activeStep={props.activeStep}
        connector={<ColorlibConnector />}
        sx={{
          display: { xs: "none", sm: "flex" },
        }}
      >
        {steps.map((step) => (
          <Step key={step.label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>
              {step.label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </>
  );
  function ColorlibStepIcon(props: StepIconProps) {
    const { active, completed, className, icon } = props;
    return (
      <>
        <ColorlibStepIconRoot
          ownerState={{ completed, active }}
          className={className}
          sx={{
            display: { xs: "flex", sm: "none" },
            "& .MuiStepIcon-root": {
              color: active || completed ? "#222D35" : "#8a8f93ff",
              width: "24px",
              height: "24px",
            },
          }}
        >
          {selectedStep.icon}
        </ColorlibStepIconRoot>
        <ColorlibStepIconRoot
          ownerState={{ completed, active }}
          className={className}
          sx={{
            display: { xs: "none", sm: "flex" },
            "& .MuiStepIcon-root": {
              color: active || completed ? "#222D35" : "#8a8f93ff",
              width: "24px",
              height: "24px",
            },
          }}
        >
          {icons[Number(icon) - 1]}
        </ColorlibStepIconRoot>
      </>
    );
  }
}
